/*
  Video component styles
*/

export const videoStyles = {
  centerContent: {
    padding: "20px",
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#f4f4f6",
  },
  overlayContent: {
    position: "absolute",
    bottom: 40,
    opacity: 0.8,
    padding: "10px",
    backgroundColor: "#000000",
    zIndex: 100,
    color: "white",
    borderRadius: "4px",
  },
  videoDivContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    textAlign: "center",
    position: "relative",
    top: 0,
    left: 0,
    backgroundColor: "#000000",
    overflow: "hidden",
  },
  participantContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
  },
  footerDiv: {
    width: "100%",
    height: "70px",
    marginTop: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  maxWidthDiv: {
    maxWidth: "500px",
    minWidth: "300px",
    width: "100%",
  },
  mediaObject: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
  },
  mediaFigure: {
    marginRight: "20px",
  },
  mediaBody: {
    flex: 1,
  },
};



